module.exports = __webpack_public_path__ + "img/logo5.cdbfd724.png";